// src/fontAwesomeConfig.js
import { library } from "@fortawesome/fontawesome-svg-core";
import { faPaperPlane } from "@fortawesome/free-regular-svg-icons";

library.add(faPaperPlane);
